import React from 'react';

function Map() {
  return (
    <div className='h-[500px] w-full'>
      <iframe
        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14686.657553911494!2d72.5354601!3d23.003972!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e851893c5ce2f%3A0x1f6debafcb3eb7a1!2sMadhav%20Apartments!5e0!3m2!1sen!2sin!4v1694512655572!5m2!1sen!2sin'
        width='100%'
        height='100%'
        style={{ border: 0 }}
        allowFullScreen=''
        loading='lazy'
        referrerPolicy='no-referrer-when-downgrade'
        title='Madhav Apartments Map'
      ></iframe>
    </div>
  );
}

export default Map;
